export type ScreenShareState = { sid: string; subscribed: boolean };

export function orderScreenShares(
    order: readonly string[],
    shares: readonly ScreenShareState[]
): { order: string[]; started: boolean; ended: boolean } {
    const present = new Set(shares.map((share) => share.sid));
    const kept = order.filter((sid) => present.has(sid));
    const started = shares.filter((share) => share.subscribed && !kept.includes(share.sid)).map((share) => share.sid);
    return { order: [...kept, ...started], started: started.length > 0, ended: kept.length < order.length };
}
